import { logger, LogCategory } from './logger';
/**
 * Centralized service for sending emails
 */
export class EmailService {
    constructor() {
        Object.defineProperty(this, "apiUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'https://ai-core.dev.azcld.advisori.de/fission/fraport/api/v1/email-service'
        });
    }
    /**
     * Send an email using the email service API
     */
    async sendEmail(options) {
        try {
            logger.info('Sending email', LogCategory.GENERAL, {
                to: options.to,
                subject: options.subject
            });
            const response = await fetch(this.apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(options)
            });
            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message || 'Failed to send email');
            }
            logger.info('Email sent successfully', LogCategory.GENERAL, {
                to: options.to,
                subject: options.subject
            });
            return {
                success: true,
                message: 'Email sent successfully!',
                data
            };
        }
        catch (error) {
            logger.error('Error sending email', LogCategory.GENERAL, {
                error,
                to: options.to,
                subject: options.subject
            });
            return {
                success: false,
                message: error instanceof Error ? error.message : 'An unknown error occurred'
            };
        }
    }
}
// Create a singleton instance
export const emailService = new EmailService();
